import React from 'react';
import DisplayOffer from './DisplayOffer.view';
import OfferAccepted from './OfferAccepted.view';
import OfferDeclined from './OfferDeclined.view';
import OfferExpired from './OfferExpired.view';

import styles from './Offer.styles.module.scss';

export default function OfferView(props) {
  const { offer, onAccept, onDecline } = props;
  return (
    <div className={styles.container}>
      <DisplayOffer offer={offer} onAccept={onAccept} onDecline={onDecline} />
      <OfferAccepted offer={offer} />
      <OfferExpired offer={offer} />
      <OfferDeclined offer={offer} />
    </div>
  );
}
